import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Container,
  Box,
  Paper,
  Typography,
  Button,
} from '@mui/material';

const PendingApproval = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const data = location.state || {};

  const logoUrl =
    'https://horizons-cdn.hostinger.com/f34f6b4a-5701-45b6-9778-48a500b88e4d/00c7de63c68d9d1ea880547b4c0c04a6.png';

  const handleBackToLogin = () => {
    navigate('/login');
  };

  return (
    <Container
      maxWidth="sm"
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f6f6f8',
      }}
    >
      <Paper
        elevation={4}
        sx={{
          p: 4,
          borderRadius: 3,
          textAlign: 'center',
          background: 'white',
        }}
      >
        <Box sx={{ mb: 3 }}>
          <img
            src={logoUrl}
            alt="RTNZERO"
            style={{ width: 96, marginBottom: 12 }}
          />
          <Typography variant="h5" fontWeight="bold" gutterBottom>
            Application received
          </Typography>
        </Box>

        <Typography variant="body1" sx={{ mb: 2 }}>
          Thank you
          {data.firstName ? `, ${data.firstName}` : ''} for applying to access the
          RTNZERO dashboard.
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Your account is currently <strong>pending approval</strong>. One of our
          admins will review your details and confirm your access shortly.
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          We’ll be in touch using the contact details you provided to share next
          steps and confirm your access.
        </Typography>

        <Button
          variant="contained"
          color="primary"
          fullWidth
          sx={{ mt: 1, mb: 2, borderRadius: 2 }}
          onClick={handleBackToLogin}
        >
          Back to login
        </Button>

        <Typography variant="caption" color="text.secondary">
          You can return and sign in again any time. Once approved, you’ll be taken
          straight into your dashboard.
        </Typography>
      </Paper>
    </Container>
  );
};

export default PendingApproval;

